import React, {useEffect, useState} from "react";
import api from "../../api/api";
import moment from "moment";
import {
    getActiveLicenceCount_URL,
    getIssuedLicencesCount_URL,
    getIssuedLicencesCountBySoftwareProduct_URL,
    getIssuedLicencesCountByYear_URL,
    getLicencesThatExpireUntilDateCount_URL,
    getRegisteredCompanyCount_URL
} from "../../constants/urlConfig";

const ISSUE_DAYS_TO_SUBTRACT_DEFAULT = 30,
    EXPIRATION_DAYS_THRESHOLD_DEFAULT = 90;

const useController = () => {
    const [registeredCompanyCount, setRegisteredCompanyCount] = useState('-');
    const [activeLicenceCount, setActiveLicenceCount] = useState('-');
    const [issuedLicenceCount, setIssuedLicenceCount] = useState('-');
    const [expiringLicenceCount, setExpiringLicenceCount] = useState('-');
    const [issueDaysToSubtract, setIssueDaysToSubtract] = useState(ISSUE_DAYS_TO_SUBTRACT_DEFAULT);
    const [expirationDaysThreshold, setExpirationDaysThreshold] = useState(EXPIRATION_DAYS_THRESHOLD_DEFAULT);

    const [licencesBySoftwareProducts, setLicencesBySoftwareProducts] = useState([]);
    const [licencesByYear, setLicencesByYear] = useState([]);

    useEffect(async () => {
        const {data: {value}} = await api.get(getIssuedLicencesCountBySoftwareProduct_URL);

        const licences = [];
        for (let prop in value) {
            licences.push({
                country: 'VLM',
                description: prop,
                year: '1750',
                value: value[prop]
            })
        }

        setLicencesBySoftwareProducts(licences);
    }, []);

    useEffect(async () => {
        const {data: {value}} = await api.get(getIssuedLicencesCountByYear_URL);
        const licencesByYear = [];
        for (let prop in value) {
            licencesByYear.push({
                year: prop,
                value: value[prop]
            })
        }
        setLicencesByYear(licencesByYear)
    }, []);

    useEffect(async () => {
        const {data: {value}} = await api.get(getRegisteredCompanyCount_URL);
        setRegisteredCompanyCount(value);
    }, []);

    useEffect(async () => {
        const {data: {value}} = await api.get(getActiveLicenceCount_URL);
        setActiveLicenceCount(value);
    }, []);

    useEffect(async () => {
        const date = moment().subtract(issueDaysToSubtract, 'days');
        const {data: {value}} = await api.get(getIssuedLicencesCount_URL.replace('{date}', date.toDate().getTime()));
        setIssuedLicenceCount(value);
    }, [issueDaysToSubtract]);

    useEffect(async () => {
        const date = moment().subtract(expirationDaysThreshold, 'days');
        const {data: {value}} = await api.get(getLicencesThatExpireUntilDateCount_URL.replace('{date}', date.toDate().getTime()));
        setExpiringLicenceCount(value);
    }, [expirationDaysThreshold]);

    return {
        registeredCompanyCount,
        activeLicenceCount,
        issuedLicenceCount,
        expiringLicenceCount,
        issueDaysToSubtractDefault: ISSUE_DAYS_TO_SUBTRACT_DEFAULT,
        expirationDaysThresholdDefault: EXPIRATION_DAYS_THRESHOLD_DEFAULT,
        issueDaysToSubtract,
        expirationDaysThreshold,
        onIssuedDaysToSubtractChanged: setIssueDaysToSubtract,
        onExpiringDaysToSubtractChanged : setExpirationDaysThreshold,
        licencesBySoftwareProducts,
        licencesByYear
    }
};

export default useController;